<template>
    <div>
        <el-dialog
            :visible.sync="$store.state.bindPhoneDialog"
            custom-class="loginmodalwrap"
            :close-on-press-escape= false
            :close-on-click-modal= false
            :before-close="hideDialog"
        >
            <div class="loginwrap" >
                <!-- <div class="loginlogo">
                    <img src="/static/img/logo.png" alt="">
                </div> -->

                <div v-if="type === 'default'">
                    <div class="bindText">
                        <p>您的微信还未绑定手机账户!</p>
                        <p>请选择关联已有账户,或者绑定新手机号</p>
                    </div>

                    <div class="bindBtn">
                        <el-button  type="primary" style="width: 100%" @click="goType('exist')">关联已有账号</el-button>
                        <el-button type="info" style="width: 100%; margin-top: 17px" @click="goType('none')">绑定手机号</el-button>
                    </div>
                </div>

                <div v-if="type === 'exist'"  key="exists">
                    <div class="logintiptitle" >
                        <div style="width: 218px;"></div>
                        <span>关联已有账号</span>
                    </div>
                    <el-form :model="existForm" ref="existForm" :rules="existFormRules"> 
                        <el-form-item prop="account">
                            <el-input v-model="existForm.account"  size="medium" placeholder="手机号码"></el-input>
                        </el-form-item>

                        <el-form-item prop="password">
                            <el-input v-model="existForm.password" type="password"  size="medium" placeholder="请输入密码"></el-input>
                        </el-form-item>

                        <el-form-item>
                            <el-button type="primary" style="width: 100%" @click="bindexist('existForm')">登 录</el-button>
                        </el-form-item>

                        <el-form-item>
                            <el-button plain style="width: 100%" @click="type = 'none' ">绑定手机号</el-button>
                        </el-form-item>

                        <!-- <el-form-item> -->
                            <!-- <div class="logintipwrap_amend">
                                <a  href="javascript:;" @click="retrievepwd('cpwd')">绑定手机号</a>
                            </div> -->
                            <!-- <div class="loginthreelogin">
                                <p>
                                    <a  href="javascript:;" @click="type = 'none' ">绑定手机号</a>
                                </p>
                            </div> -->
                        <!-- </el-form-item> -->
                    </el-form>
                </div>

                <div v-if="type === 'none'"  key="nones">
                    <div class="logintiptitle">
                        <div style="width: 218px;"></div>
                        <span>绑定手机号</span>
                    </div>

                    <el-form :model="registerform"  ref="registerform" :rules="registerFormRules">
                        <!-- <el-form-item prop="username">
                        <el-input v-model.trim="registerform.username" size="medium" placeholder="请输入昵称" @blur="queryName(registerform.username)"></el-input>
                        </el-form-item> -->
                        <el-form-item prop="account">
                        <el-input v-model.trim="registerform.account" size="medium" placeholder="请输入手机号码"></el-input>
                        </el-form-item>
                        <el-form-item>
                        <el-row>
                            <el-col :span="14">
                            <el-form-item prop="verifycode">
                                <el-input v-model.trim="registerform.verifycode" class="ipt verifycode" placeholder="请输入验证码"></el-input>
                            </el-form-item>
                            </el-col>
                            <el-col :span="9" :offset="1">
                                <!-- @click.stop="getcode" -->
                            <el-button v-if="!registerform.starttime" @click="getcode" type="primary" plain class="verifycodebtn">获取验证码</el-button>
                            <el-button v-else type="primary" plain class="verifycodebtn" long disabled>{{registerform.runtime}}秒后重发</el-button>
                            </el-col>
                        </el-row>
                        </el-form-item>
                        <el-form-item prop="password">
                        <el-input type="password" v-model.trim="registerform.password" size="medium" placeholder="请输入密码"></el-input>
                        </el-form-item>
                        <el-form-item prop="repassword">
                        <el-input type="password" v-model.trim="registerform.repassword" size="medium" placeholder="请确认密码"></el-input>
                        </el-form-item>
                        <el-form-item>
                        <el-checkbox v-model="registerform.read" class="regreadxieyi">已阅读并同意平台<router-link class="a-name" target="_blank" :to="{path: '/agreement/userAgreement'}">《用户协议》</router-link>、
                        <router-link class="a-name" target="_blank" :to="{path: '/agreement/payAgreement'}">《支付协议》</router-link></el-checkbox>
                        <!-- <el-checkbox v-model="registerform.read" class="regreadxieyi">已阅读并同意平台<a target="_blank" :href="$gotov1('/agreement', true)">《用户协议》</a>、<a target="_blank" :href="$gotov1('/agreement/payAgreement', true)">《支付协议》</a></el-checkbox> -->
                        </el-form-item>
                        <el-form-item>
                            <!-- @click="registerfn('registerform')" -->
                            
                        <el-button  :loading="registerning" type="primary" style="width: 100%" @click="register('registerform')">绑 定</el-button>
                        </el-form-item>
                        <el-form-item>
                        <div class="loginthreelogin">
                            <!-- @click="type = 'login'" -->
                            <p>
                                <!-- <span>已有账号?</span> -->
                                <!-- &lt;&lt; -->
                                <a  href="javascript:;" @click="type = 'exist' ">关联已有账号</a>
                            </p>
                            
                        </div>
                        </el-form-item>
                    </el-form>
                </div>

                <div v-if="type === 'success'">
                    <div class="bindText" >
                        <p>您的账号已成功绑定微信!</p>
                        <p style="padding: 0 45px">请关注 "弘商法律云平台" 服务号, 可在微信中接收通知</p>
                    </div>

                    <div class="bindText" style="height: 170px">
                        <img src="/static/img/qrcode.png" alt="" style="width: 148px; height: 148px">
                    </div>

                    <!-- @click="goType('success')" -->
                     
                    <el-button type="primary" style="width: 100%" @click="goHome">进入弘商法律云平台</el-button>
                </div>
      
            </div>


        </el-dialog>
    </div>
</template>

<script>
import sockets from '@/socket';
export default {
    data() {
        var validName = (rule, value, callback) => {
            // if (!/[@#\$%\^&\*]+/g.test(value)) {
            //     console.log(4)
            //     return callback(new Error('请勿包含非法字符'))
            // }
            if (!value) {
                return callback(new Error('昵称不能为空'))
            }
            if (/[@#\$%\^&\*]+/g.test(value)) {
                return callback(new Error('请勿包含非法字符'))
            }
            if (value.length > 9) {
                return callback(new Error('长度在1-9之间'))
            }
            setTimeout(() => {
                let option = {
                    name : value
                }

                this.$http.post('/nameverify', option).then(res => {
                    if(res.data.retcode === 0) {
                        callback()
                    } else {
                        return callback(new Error('昵称已被注册'))
                    }
                })
            }, 500)
        }

        var checkPhone = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('手机不能为空'))
            }
            if (/^1[0-9]{10}$/.test(value)) {
                this.$http.get('/isrepetitionbyphone',{params:{phone:value}}).then(res =>{
                    if (res.data.isRepetition === 0) {
                      this.getCodeStatus = true
                      callback()
                    } else {
                      this.getCodeStatus = false
                      callback(new Error('手机号码已被注册'))
                    }
                })
            } else {
                return callback(new Error('手机号码错误'))
            }
        }

        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                if (this.registerform.password !== '') {
                    this.$refs.registerform.validateField('repassword');
                }
                callback();
            }
        };

        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.registerform.password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };


        return {
            bindModal: true,
            type: 'default',
            existForm: {
                account: '',
                password: null
            },
            existFormRules: {
                account: [
                    {required: true, message: '请输入手机', trigger: 'blur'}
                ],
                password: [
                    {required: true, message: '请输入密码', trigger: 'blur'},
                    {min: 6, message: '请输入不少于6位数密码', trigger: 'blur'}
                ]
            },
            registerform: {
                username: '',
                account: '',
                verifycode: '',
                password: '',
                repassword: '',
                read: true,
                accounttype: '',
                againtime: 60,
                runtime: 60,
                starttime: false
            },
            registerning: false,
            getCodeStatus:false,
            registerFormRules: {
                // username: [
                //     { required: true, validator: validName, trigger: 'blur' },
                // ],
                account: [
                    { required: true, validator: checkPhone, trigger: 'blur' },
                ],
                verifycode: [
                    { required: true, min: 4, max: 6, message: '验证码错误', trigger: 'blur' }
                ],
                password: [
                    { validator: validatePass, trigger: 'blur' },
                    { min: 6, message: '请输入不少于6位数密码', trigger: 'blur' }
                ],
                repassword: [
                    { validator: validatePass2, trigger: 'blur' },
                    { min: 6, message: '请输入不少于6位数密码', trigger: 'blur' }
                ]

            }
        }
    },
    computed: {
        getStatus() {
            if (this.$store.state.minInfo) {
                return this.$store.state.minInfo.phone
            } else {
                return false
            }  
        }
    },
    methods: {
        hideDialog() {
            if (this.type === 'success') {
                this.goHome()
                return false
            }
            if(window.socket){
                window.socket.close();
            }
            this.$ajax('post', 'logout', (data) => {
                this.$store.commit('clearalldata');
                this.$store.commit('changebindPhone', false)
                this.$message.success('退出登录成功！');
                this.type = 'default'
                this.$router.push({name: 'home'});
            });
        },

        goType(type) {
            this.type = type
        },

        // 忘记密码
        retrievepwd(type) {
            this.hideDialog()

            setTimeout(() => {
                this.$store.commit('changeLoginModalStatus', {display: true, type: type})
            }, 500)
        },

        bindexist(formName) {
            this.$refs[formName].validate((valid) => {
                if(valid) {

                    let url = '/userinfo/wechatbundphoneaccount'
                    let option = Object.assign({}, this.existForm)
                    this.$ajax('post', 'userinfo/phoneaccountverifywechat', option, res=> {
                        if (res.retcode === 0) {
         
                            if (res.hasWechat === 0) {
                                this.$ajax('post', url, option , res => {
                                    this.type = 'success'
                                    this.getMine()
                                    this.existForm = {
                                        account: '',
                                        password: null
                                    }
                                })
                            } else {
                                const h = this.$createElement;
                                this.$msgbox({
                                    title: "确认对话框",
                                    message: h("p", null, [
                                    h("i", { class: "el-icon-question", style: "color: #ff9900;font-size: 30px;vertical-align: middle;" }),
                                    h("span", {style: 'margin-left: 20px; '}, "该手机账号已绑定微信，是否更换绑定?")
                                    ]),
                                    showCancelButton: true,
                                    showClose: false,
                                    cancelButtonText: '取消',
                                    confirmButtonText: '确定',
                                    beforeClose: (action, instance, done) => {
                                        if (action === 'confirm') {
                                        this.$ajax('post', url, option , res => {
                                            this.type = 'success'
                                            this.getMine()
                                            this.existForm = {
                                                account: '',
                                                password: null
                                            }
                                            done()
                                        })
                                            
                                        } else {
                                            console.log('取消')
                                            done()
                                        }
                                    }
                                }).then(action => {
                                    console.log('完毕')
                                }).catch(() => {
                                    return false
                                })
                            }
                        }
                    })

   
                    
                } else {
                    console.log('error submit !')
                    return false
                }
            })
        },
        getcode() {
            if(this.getCodeStatus){
                let accpet = "";
                this.$refs.registerform.validateField('account', cb => { accpet = cb });
                if( accpet != "" ){
                    return false;
                }
                this.starttime('registerform');
                let url = 'sms/verifycode'
                let param = {
                    phone: this.registerform.account, 
                    type: 'register' 
                }
                this.$http.post(url, param).then(response => {
                    if( response.data.retcode == $conf.RETCODE_OK ){
                        this.$message.success( '获取验证码成功，请查收！' );
                    }else{
                        this.registerform.runtime = 0;
                        this.$message.error( response.data.errmsg );
                    }
                }).catch(err => {
                    if( err.response ) {
                        switch( err.response.status ) {
                            case 429:
                            this.$message.error( '发送验证码太频繁，请稍后重试！' );
                        }
                    }
                });
            }
        },

        setTime(ref) {
            setTimeout(() => {
                if( this[ref].runtime <= 0 ){
                this[ref].starttime = false;
                }else{
                this[ref].runtime -= 1;
                this.setTime(ref);
                }
            }, 1000);
        },

        starttime(ref) {
            this[ref].starttime = true;
            this[ref].runtime = this[ref].againtime;
            this.setTime(ref);
        },

        register(formName) {
            if (this.registerning) {
                return
            }

            if (!this.registerform.read) {
                this.$message.error( '未同意平台《用户协议》、《支付协议》，无法注册！' )
                return false
            }
            
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.registerning = true
                    

                    let param = { 
                        // name: this.registerform.username, 
                        phone: this.registerform.account,
                        password: this.registerform.password, 
                        code: this.registerform.verifycode, 
                    };
                    this.$http.post('userinfo/wechatbundnewphone', param).then(res => {
                        if (res.data.retcode === $conf.RETCODE_OK) {
                            this.$message.success('注册成功')
                            this.getMine()
                            // 从哪来回哪去
                            if( this.$route.query.callbackurl && this.$route.query.showtype ){
                                window.location.replace(this.$route.query.callbackurl);
                                return;
                            }
                            let v = res.data.data;
                            this.$store.commit('changeloginStatus', true);
                            this.$store.commit('changeMineInfo', v);
                            this.$store.commit('changebindPhone', false);
                            if(window.socket){
                                window.socket.close();
                            }
                            sockets(v.id);
                            // this.modalHandleClose()
                        } else {
                            this.$message.error( res.data.errmsg)
                        }
                        this.registerning = false
                    }).catch(err => {
                        this.registerning = false
                    })
                }
            })


        },

        modalHandleClose() {
            this.$store.commit('changebindPhone', false);
        },

        goHome() {
            this.$store.commit('changebindPhone', false)
            this.$router.push({name: 'home'})
        },

        // 获取用户名是否重复
        queryName(name) {
            console.log(name)
        },

        getMine() {
            let url = 'userinfo/mine'
            this.$http.get(url).then((res) => {
                let data = res.data
                if (data.retcode === $conf.RETCODE_OK) {
                    // if (data.data.phone === null || data.data.phone === '') {
                    //     this.$store.commit('changebindPhone', true)
                    // }
                    this.$store.commit('changeloginStatus', true);
                    this.$store.commit('changeMineInfo', data.data);
                    sockets(data.data.id);
                    // 未绑定微信 跳去绑定微信页面
                    // if( !data.data.wechat ){
                    //     this.$gotov1('');
                    // }
                    } else {
                        console.log(data.errmsg);
                    }
            })
        }
    },
    mounted() {
        // console.log(this.getStatus)
    }
}
</script>

<style lang="stylus">
.loginmodalwrap
    width: 400px !important
    border-radius 5px
    .el-dialog__header
        padding: 0
    .loginwrap
        padding: 14px 30px 0
        .loginlogo
            text-align: center
        .logintiptitle
            position: relative
            text-align: center
            color: #bbb
            font-size: 16px
            margin: 16px 0 15px
            div
                position: absolute
                top: 50%
                left: 50%
                right: 0
                height: 1px
                background: #eee
                margin-top: -1px
                transform: translateX(-50%)
            span
                position: relative
                padding: 0 30px
                background: #fff
                color #737373
                font-size 16px
    .logintipwrap_amend
        line-height 30px
        text-align right 
    .bindText
        text-align center
        height 100px
        p:first-child
            font-size 20px
            color #393939
            margin-top 20px
            line-height 34px
        p:last-child
            color #666
            font-size 12px
    .bindBtn
        margin-bottom 40px
</style>



// WEBPACK FOOTER //
// src/components/login/bindPhone.vue